<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.groupId"
        placeholder="班组名称"
        clearable
      >
        <el-option
          v-for="(item, i) in groupList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.graduationStatus"
        placeholder="结业状态"
        clearable
      >
        <el-option
          v-for="(item, i) in graduationStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.name"
        placeholder="姓名/房间号"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import butn from "@/components/button/index";
export default {
  components: { butn },
  props: {
    groupList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filters: {
      },
      graduationStatusData: [],
    };
  },
  created() {
    this.getSysParamByTypes(["CLASS_FINISH_STATUS"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        let data = JSON.parse(JSON.stringify(res.data));
        this.$emit("setGraduationStatusData", data["CLASS_FINISH_STATUS"]);
        this.graduationStatusData = res.data["CLASS_FINISH_STATUS"];
      });
    },

    initData() {
      // , t: new Date().getTime()
      this.$emit("search", {
        ...this.filters,
      });
    },
    resetData() {
      this.filters = { };
      this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
</style>
